import {
  AdminSubHeaderMainLayout,
  AdminSubHeaderMainLayoutV3_1,
} from 'Components/Display';
import { useEntity, useGlobalContext } from 'Context';
import { ROUTES } from 'Navigation';
import React, { Fragment } from 'react';
import { ViewReferralsRequestBreadcrumbs } from '.';
import { ReferralOwnershipModal, useOwnershipModal } from '../Referrals/ReferralOwnershipModal';
import { ReferralOwnershipBanner } from '../Referrals/ReferralOwnershipBanner';
import { useParams } from 'react-router-dom';

export const ReferralsRequestMain: React.FC = () => {
  const entity = useEntity();
  const { id: urlId } = useParams<{ id: string }>();
  const userdata = useGlobalContext()[0]?.currentUser;

  const id = urlId || entity?.id;

  const { isInternalUser, showModal, showBanner, bannerInfo, handleOwnershipClaimed, handleModalDismiss, handleDeny } =
    useOwnershipModal(entity, userdata, id);

  return (
    <Fragment>
      {isInternalUser && (
        <ReferralOwnershipModal
          isOpen={showModal}
          toggle={handleModalDismiss}
          entityId={id}
          hasExistingOwner={entity?.hasOwner || false}
          existingOwnerName={entity?.ownerName || ''}
          onOwnershipClaimed={handleOwnershipClaimed}
          onDeny={handleDeny}
          apiEndpoint="referralsRequests/ClaimOwnership"
          entityIdField="referralsRequestId"
          entityLabel="referral request"
        />
      )}
      {showBanner && (
        <ReferralOwnershipBanner
          isOwner={bannerInfo.isOwner}
          ownerName={bannerInfo.ownerName}
        />
      )}
      <ViewReferralsRequestBreadcrumbs />
      <AdminSubHeaderMainLayout
        subRoute={ROUTES.REFERRALSREQUEST}
        title={
          (entity?.stradixNumber ? `#${entity?.stradixNumber} - ` : '') +
          entity.name +
          ' - Referral Request'
        }
      />
    </Fragment>
  );
};

export const ReferralsRequestMainV3_1: React.FC = () => {
  const entity = useEntity();
  const { id: urlId } = useParams<{ id: string }>();
  const userdata = useGlobalContext()[0]?.currentUser;

  const id = urlId || entity?.id;

  const { isInternalUser, showModal, showBanner, bannerInfo, handleOwnershipClaimed, handleModalDismiss, handleDeny } =
    useOwnershipModal(entity, userdata, id);

  return (
    <Fragment>
      {isInternalUser && (
        <ReferralOwnershipModal
          isOpen={showModal}
          toggle={handleModalDismiss}
          entityId={id}
          hasExistingOwner={entity?.hasOwner || false}
          existingOwnerName={entity?.ownerName || ''}
          onOwnershipClaimed={handleOwnershipClaimed}
          onDeny={handleDeny}
          apiEndpoint="referralsRequests/ClaimOwnership"
          entityIdField="referralsRequestId"
          entityLabel="referral request"
        />
      )}
      {showBanner && (
        <ReferralOwnershipBanner
          isOwner={bannerInfo.isOwner}
          ownerName={bannerInfo.ownerName}
        />
      )}
      <ViewReferralsRequestBreadcrumbs />
      <AdminSubHeaderMainLayoutV3_1
        subRoute={ROUTES.REFERRALSREQUEST}
        title={entity?.stradixNumber ? `#${entity?.stradixNumber}` : ''}
      />
    </Fragment>
  );
};
